import type { ReactNode } from 'react';
import { cx } from './cx.ts';

/**
 * Card with the standard caption bar — the uniform section container
 * (one heading recipe instead of nine). `count` renders as a signal
 * pill; `actions` sit right-aligned in the caption row.
 */
interface Props {
  readonly caption: ReactNode;
  readonly count?: number;
  readonly actions?: ReactNode;
  readonly children: ReactNode;
  readonly padded?: boolean;
  readonly className?: string;
  readonly testId?: string;
}

export function Panel({
  caption,
  count,
  actions,
  children,
  padded = false,
  className,
  testId,
}: Props): JSX.Element {
  return (
    <section
      data-testid={testId}
      className={cx('overflow-hidden rounded-lg border border-line-soft bg-card', className)}
    >
      <div className="flex items-center gap-2.5 border-b border-line-soft px-4 py-2.5">
        <h2 className="m-0 text-section text-paper">{caption}</h2>
        {count !== undefined ? (
          <span className="rounded-full bg-signal-dim px-2 py-0.5 font-mono text-micro text-signal">
            {count}
          </span>
        ) : null}
        {actions !== undefined && actions !== null ? (
          <div className="ml-auto flex items-center gap-2">{actions}</div>
        ) : null}
      </div>
      <div className={cx(padded && 'p-4')}>{children}</div>
    </section>
  );
}
